import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import FavoritesDrawer from '../components/FavoritesDrawer';
import '../styles/theme.css';

export default function PublicLayout({ children }) {
  return (
    <div>
      <Header />
      <FavoritesDrawer />
      <Breadcrumb />
      <main className="main container">
        {children || <Outlet />}
      </main>
      <Footer />
    </div>
  );
}
